import React from 'react'

const Closed = ({purpose}) => {
    const divStyle  = {display:'flex',justifyContent:'center',alignItems:'center',height:'100vh',fontSize:'40px',color:''}
    return (
        <div className='text-danger' style={divStyle}>
            {purpose}       
        </div>
    )
}

export default Closed;